import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.grey['50'],
    fontSize: '0.95rem',
  },
}));
